(function () {
  var customFabricApi = null;

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.classList || !target.classList.contains('swatch-input__input')) return;
      if (!document.getElementById('CustomFabricDrawer')) return;
      if (customFabricApi && typeof customFabricApi.clearOnStockSwatch === 'function') {
        customFabricApi.clearOnStockSwatch(target);
      }
    },
    true
  );

  function initCustomFabricDrawer() {
    var drawer = document.getElementById('CustomFabricDrawer');
    if (!drawer) {
      customFabricApi = null;
      return;
    }

    var overlay = drawer.querySelector('.custom-fabric-drawer__overlay');
    var closeButtons = drawer.querySelectorAll('[data-custom-fabric-close]');
    var stepTabs = drawer.querySelectorAll('[data-custom-fabric-step-tab]');
    var stepTwoTab = drawer.querySelector('[data-custom-fabric-step-tab="2"]');
    var stepPanels = drawer.querySelectorAll('[data-custom-fabric-step-panel]');
    var footerRows = drawer.querySelectorAll('[data-custom-fabric-footer]');
    var materialGrid = document.getElementById('CustomFabricMaterialGrid');
    var colorGrid = document.getElementById('CustomFabricColorGrid');
    var selectionPreview = document.getElementById('CustomFabricSelectionPreview');
    var colorHeading = document.getElementById('CustomFabricColorHeading');
    var specLink = document.getElementById('CustomFabricSpecLink');
    var nextButton = document.getElementById('CustomFabricNextButton');
    var backButton = document.getElementById('CustomFabricBackButton');
    var applyButton = document.getElementById('CustomFabricApplyButton');
    var applyAndOrderButton = document.getElementById('CustomFabricApplyAndOrderButton');
    var dataNode = document.getElementById('CustomFabricData');
    var materialDataNode = document.getElementById('CustomFabricMaterialData');
    var CUSTOM_FABRIC_PROPERTY_NAME = 'Selected Fabric';
    var sampleVariantId = normalizeText(drawer.getAttribute('data-fabric-sample-variant-id'));
    /* REENABLE_CUSTOMIZATION_ADDON
    var customizationAddonVariantId = normalizeText(
      drawer.getAttribute('data-customization-addon-variant-id')
    );
    var addonForProductName = normalizeText(drawer.getAttribute('data-addon-for-product-name'));
    */
    var MAX_VISIBLE_MATERIALS = 4;
    var isInline = drawer.classList.contains('custom-fabric-drawer--inline');

    if (!materialGrid || !colorGrid || !dataNode || !materialDataNode) {
      customFabricApi = null;
      return;
    }

    var rawData = [];
    try {
      rawData = JSON.parse(dataNode.textContent || '[]');
    } catch (e) {
      rawData = [];
    }

    var rawMaterialData = [];
    try {
      rawMaterialData = JSON.parse(materialDataNode.textContent || '[]');
    } catch (e) {
      rawMaterialData = [];
    }

    var fabricsByCollection = {};
    var collections = [];
    var collectionMeta = {};
    var materialMetaByNormalizedName = {};
    var materialNameByLookupKey = {};
    var hasMaterialDrivenColorData = false;
    var selectedColorsByCollection = {};
    var activeCollection = '';
    var currentStep = 1;
    var configuredProductFormId = normalizeText(drawer.getAttribute('data-product-form-id'));
    var activeProductFormId = configuredProductFormId;

    function normalizeText(value) {
      if (value == null) return '';
      if (typeof value === 'string') {
        var text = value.trim();
        if (!text) return '';

        // Some metaobject values come through as serialized JSON strings
        // like ["Amore"] or {"value":"Amore"}; unwrap those safely.
        var firstChar = text.charAt(0);
        var lastChar = text.charAt(text.length - 1);
        var looksLikeJson =
          (firstChar === '[' && lastChar === ']') ||
          (firstChar === '{' && lastChar === '}') ||
          (firstChar === '"' && lastChar === '"');

        if (looksLikeJson) {
          try {
            return normalizeText(JSON.parse(text));
          } catch (e) {
            // Fall through to raw text when not valid JSON.
          }
        }

        return text;
      }
      if (typeof value === 'number' || typeof value === 'boolean') return String(value).trim();
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i += 1) {
          var normalizedArrayValue = normalizeText(value[i]);
          if (normalizedArrayValue) return normalizedArrayValue;
        }
        return '';
      }
      if (typeof value === 'object') {
        if ('value' in value) return normalizeText(value.value);
        if ('url' in value) return normalizeText(value.url);
        if ('name' in value) return normalizeText(value.name);
        if ('label' in value) return normalizeText(value.label);
        if ('text' in value) return normalizeText(value.text);
        if ('title' in value) return normalizeText(value.title);
        if ('handle' in value) return normalizeText(value.handle);
      }
      return '';
    }

    function normalizeKey(value) {
      return normalizeText(value).toLowerCase();
    }

    function collectLookupKeysFromValue(value, keys) {
      if (value == null) return;

      if (typeof value === 'string') {
        var text = value.trim();
        if (!text) return;

        var firstChar = text.charAt(0);
        var lastChar = text.charAt(text.length - 1);
        var looksLikeJson =
          (firstChar === '[' && lastChar === ']') ||
          (firstChar === '{' && lastChar === '}') ||
          (firstChar === '"' && lastChar === '"');

        if (looksLikeJson) {
          try {
            collectLookupKeysFromValue(JSON.parse(text), keys);
          } catch (e) {
            // Fall through and keep the raw string as a candidate key.
          }
        }

        var normalizedText = normalizeKey(text);
        if (normalizedText && keys.indexOf(normalizedText) === -1) {
          keys.push(normalizedText);
        }
        return;
      }

      if (typeof value === 'number' || typeof value === 'boolean') {
        var normalizedPrimitive = normalizeKey(String(value));
        if (normalizedPrimitive && keys.indexOf(normalizedPrimitive) === -1) {
          keys.push(normalizedPrimitive);
        }
        return;
      }

      if (Array.isArray(value)) {
        value.forEach(function (item) {
          collectLookupKeysFromValue(item, keys);
        });
        return;
      }

      if (typeof value === 'object') {
        var prioritizedKeys = [
          'id',
          'handle',
          'name',
          'display_name',
          'displayName',
          'title',
          'label',
          'value',
          'text',
          'url',
          'system'
        ];

        prioritizedKeys.forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(value, key)) {
            collectLookupKeysFromValue(value[key], keys);
          }
        });

        Object.keys(value).forEach(function (key) {
          collectLookupKeysFromValue(value[key], keys);
        });
      }
    }

    function getLookupKeys(values) {
      var keys = [];
      (values || []).forEach(function (value) {
        collectLookupKeysFromValue(value, keys);
      });
      return keys;
    }

    function sortAlphabetically(left, right) {
      return left.localeCompare(right, undefined, { sensitivity: 'base' });
    }

    function getCollectionMeta(collectionName) {
      var rawMeta = collectionMeta[collectionName] || {};
      var mappedMaterialMeta = materialMetaByNormalizedName[normalizeKey(collectionName)] || {};

      return {
        image: mappedMaterialMeta.image || rawMeta.image || null,
        subText: mappedMaterialMeta.subText || rawMeta.subText || '',
        specificationSheetUrl:
          mappedMaterialMeta.specificationSheetUrl || rawMeta.specificationSheetUrl || ''
      };
    }

    rawMaterialData.forEach(function (entry) {
      var materialName = normalizeText(entry.name);
      var materialHandle = normalizeText(entry.handle);
      var materialId = normalizeText(entry.id);
      var relatedFabrics = Array.isArray(entry.relatedFabrics) ? entry.relatedFabrics : [];
      if (!materialName) return;

      materialMetaByNormalizedName[normalizeKey(materialName)] = {
        image: entry.image || null,
        subText: normalizeText(entry.subText),
        specificationSheetUrl: normalizeText(entry.specificationSheetUrl)
      };

      getLookupKeys([materialName, materialHandle, materialId]).forEach(function (key) {
        materialNameByLookupKey[key] = materialName;
      });

      if (collections.indexOf(materialName) === -1) {
        collections.push(materialName);
      }

      if (!fabricsByCollection[materialName]) {
        fabricsByCollection[materialName] = [];
      }

      if (Array.isArray(entry.relatedFabrics)) {
        hasMaterialDrivenColorData = true;
      }

      relatedFabrics.forEach(function (relatedEntry) {
        var colorName = normalizeText(relatedEntry && relatedEntry.color);
        if (!colorName) return;
        fabricsByCollection[materialName].push({
          color: colorName,
          image: (relatedEntry && relatedEntry.image) || null
        });
      });
    });

    if (!hasMaterialDrivenColorData) {
      rawData.forEach(function (entry) {
        var selectedMaterialName = normalizeText(entry.selectedMaterial);
        var selectedMaterialHandle = normalizeText(entry.selectedMaterialHandle);
        var selectedMaterialId = normalizeText(entry.selectedMaterialId);
        var matchedMaterialName = '';
        var relationLookupKeys = getLookupKeys([
          selectedMaterialName,
          selectedMaterialHandle,
          selectedMaterialId,
          entry.selectedMaterialRaw,
          entry.selectedMaterialValueRaw
        ]);
        var hasExplicitRelation = relationLookupKeys.length > 0;

        relationLookupKeys.forEach(function (key) {
          if (!matchedMaterialName && materialNameByLookupKey[key]) {
            matchedMaterialName = materialNameByLookupKey[key];
          }
        });

        var collectionName = matchedMaterialName || (hasExplicitRelation ? selectedMaterialName : '');
        var colorName = normalizeText(entry.color);
        if (!collectionName || !colorName) return;
        if (rawMaterialData.length && !matchedMaterialName) return;

        if (!fabricsByCollection[collectionName]) {
          fabricsByCollection[collectionName] = [];
        }

        if (collections.indexOf(collectionName) === -1) {
          collections.push(collectionName);
        }

        fabricsByCollection[collectionName].push({
          color: colorName,
          image: entry.image || null
        });

        if (!collectionMeta[collectionName]) {
          collectionMeta[collectionName] = {
            image: entry.image || null,
            subText: '',
            specificationSheetUrl: ''
          };
        }
      });
    }

    // Prefer the explicitly configured material entries when available.
    // Then enforce a stable A-Z order with a hard max of four cards.
    if (rawMaterialData.length) {
      collections = collections.filter(function (collectionName) {
        return !!materialMetaByNormalizedName[normalizeKey(collectionName)];
      });
    }
    collections = collections.sort(sortAlphabetically).slice(0, MAX_VISIBLE_MATERIALS);

    if (activeCollection && collections.indexOf(activeCollection) === -1) {
      activeCollection = '';
    }

    if (!activeCollection && collections.length) {
      activeCollection = collections[0];
    }

    function setStep(step) {
      // Inline mode has no steps: materials always show, colours stack below
      // them once a material is chosen — the same top-to-bottom flow as the
      // builder's other choice groups.
      if (isInline) {
        stepPanels.forEach(function (panel) {
          var isColorPanel = panel.getAttribute('data-custom-fabric-step-panel') === '2';
          panel.classList.toggle('is-hidden', isColorPanel && !activeCollection);
        });
        return;
      }

      currentStep = step === 2 ? 2 : 1;

      stepPanels.forEach(function (panel) {
        panel.classList.toggle(
          'is-hidden',
          panel.getAttribute('data-custom-fabric-step-panel') !== String(currentStep)
        );
      });

      footerRows.forEach(function (row) {
        row.classList.toggle(
          'is-hidden',
          row.getAttribute('data-custom-fabric-footer') !== String(currentStep)
        );
      });

      stepTabs.forEach(function (tab) {
        var isTabActive = tab.getAttribute('data-custom-fabric-step-tab') === String(currentStep);
        tab.classList.toggle('is-active', isTabActive);
        tab.setAttribute('aria-current', isTabActive ? 'step' : 'false');
      });
    }

    function syncStepTwoAvailability() {
      if (!stepTwoTab) return;
      stepTwoTab.disabled = !activeCollection;
    }

    function formatSelectionValue() {
      var parts = [];
      Object.keys(selectedColorsByCollection).forEach(function (collectionName) {
        var colors = selectedColorsByCollection[collectionName] || [];
        if (!colors.length) return;
        parts.push(collectionName + ' - ' + colors.join(', '));
      });
      return parts.join(' | ');
    }

    /* The selection as its two halves, for listeners that store them apart. */
    function getSelectionParts() {
      var parts = { material: '', color: '' };
      Object.keys(selectedColorsByCollection).forEach(function (collectionName) {
        var colors = selectedColorsByCollection[collectionName] || [];
        if (parts.material || !colors.length) return;
        parts.material = collectionName;
        parts.color = colors.join(', ');
      });
      return parts;
    }

    function getAddToCartFormById(formId) {
      if (!formId) return null;
      var form = document.getElementById(formId);
      if (!form || form.tagName !== 'FORM') return null;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return null;
      return form;
    }

    function resolveProductFormFromTrigger(trigger) {
      if (!trigger) return null;

      if (trigger.tagName === 'INPUT') {
        var inputFormId = normalizeText(trigger.getAttribute('form'));
        var inputForm = getAddToCartFormById(inputFormId);
        if (inputForm) return inputForm;
      }

      if (trigger.tagName === 'LABEL') {
        var associatedInputId = normalizeText(trigger.getAttribute('for'));
        if (associatedInputId) {
          var associatedInput = document.getElementById(associatedInputId);
          if (associatedInput) {
            var associatedInputForm = resolveProductFormFromTrigger(associatedInput);
            if (associatedInputForm) return associatedInputForm;
          }
        }
      }

      var closestAddToCartForm = trigger.closest('form[data-type="add-to-cart-form"]');
      if (closestAddToCartForm) return closestAddToCartForm;

      return null;
    }

    function setActiveProductFormFromTrigger(trigger) {
      var resolvedForm = resolveProductFormFromTrigger(trigger);
      if (!resolvedForm) return null;

      if (resolvedForm.id) {
        activeProductFormId = resolvedForm.id;
      }

      return resolvedForm;
    }

    function getTargetProductForm() {
      var targetForm = getAddToCartFormById(activeProductFormId) || getAddToCartFormById(configuredProductFormId);
      if (targetForm) return targetForm;

      var addToCartForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      if (!addToCartForms.length) return null;

      var checkedCustomFabricInput = document.querySelector('.swatch-input__input[value="Customise Fabric"]:checked');
      var checkedInputForm = resolveProductFormFromTrigger(checkedCustomFabricInput);
      if (checkedInputForm) return checkedInputForm;

      return addToCartForms[0];
    }

    function updatePreview() {
      var value = formatSelectionValue();
      if (!value) {
        selectionPreview.textContent = '';
        selectionPreview.classList.add('is-empty');
        return;
      }
      selectionPreview.classList.remove('is-empty');
      selectionPreview.textContent = value;
    }

    function updateSelectedFabricDisplay(value) {
      var displayTarget = document.querySelector('.selected-custom-fabric');
      if (!displayTarget) {
        displayTarget = document.querySelector('[data-custom-fabric-selected]');
      }

      if (!displayTarget) {
        var customFabricLabel = document.querySelector('.swatch-input__label[data-custom-fabric-trigger="true"]');
        if (customFabricLabel && customFabricLabel.parentNode) {
          displayTarget = document.createElement('p');
          displayTarget.setAttribute('data-custom-fabric-selected', 'true');
          displayTarget.className = 'custom-fabric-selected';
          customFabricLabel.parentNode.insertBefore(displayTarget, customFabricLabel.nextSibling);
        }
      }

      if (displayTarget) {
        displayTarget.textContent = value ? 'Selected Fabric: ' + value : '';
      }
    }

    function updateProductFormProperty(value) {
      var productForm = getTargetProductForm();
      if (!productForm) return;

      var inputName = 'properties[' + CUSTOM_FABRIC_PROPERTY_NAME + ']';
      var existingInput = productForm.querySelector('input[name="' + inputName + '"]');

      if (!value) {
        if (existingInput) {
          existingInput.parentNode.removeChild(existingInput);
        }
        return;
      }

      if (!existingInput) {
        existingInput = document.createElement('input');
        existingInput.type = 'hidden';
        existingInput.name = inputName;
        productForm.appendChild(existingInput);
      }

      existingInput.value = value;
    }

    function syncCurrentSelectionToForm() {
      var selectionValue = formatSelectionValue();
      updateProductFormProperty(selectionValue);
      /* REENABLE_CUSTOMIZATION_ADDON
      updateCustomizationAddonPreference(selectionValue);
      */
    }

    /* REENABLE_CUSTOMIZATION_ADDON
    function updateCustomizationAddonPreference(selectionValue) {
      var productForm = getTargetProductForm();
      if (!productForm) return;

      var parsedAddonVariantId = Number(customizationAddonVariantId);
      var hasValidAddonVariantId =
        Number.isFinite(parsedAddonVariantId) && parsedAddonVariantId > 0;

      if (!selectionValue || !hasValidAddonVariantId) {
        productForm.removeAttribute('data-customization-addon-variant-id');
        productForm.removeAttribute('data-addon-for-product-name');
        return;
      }

      productForm.setAttribute('data-customization-addon-variant-id', String(parsedAddonVariantId));
      if (addonForProductName) {
        productForm.setAttribute('data-addon-for-product-name', addonForProductName);
      } else {
        productForm.removeAttribute('data-addon-for-product-name');
      }
    }
    */

    function updateOrderFabricSamplePreference(shouldOrderSample) {
      var productForm = getTargetProductForm();
      if (!productForm) return;

      if (shouldOrderSample && sampleVariantId) {
        productForm.setAttribute('data-custom-fabric-order-sample', 'true');
        productForm.setAttribute('data-custom-fabric-sample-variant-id', sampleVariantId);
        return;
      }

      productForm.removeAttribute('data-custom-fabric-order-sample');
      productForm.removeAttribute('data-custom-fabric-sample-variant-id');
    }

    function setApplyState() {
      var value = formatSelectionValue();
      if (applyButton) {
        applyButton.disabled = !value;
      }
      if (applyAndOrderButton) {
        applyAndOrderButton.disabled = !value || !sampleVariantId;
      }
    }

    function renderMaterialCards() {
      materialGrid.innerHTML = '';
      if (!collections.length) {
        var emptyItem = document.createElement('p');
        emptyItem.className = 'custom-fabric-empty';
        emptyItem.textContent = 'Selected Fabric options have not been configured for this product yet.';
        materialGrid.appendChild(emptyItem);
        return;
      }

      collections.forEach(function (collectionName) {
        var meta = getCollectionMeta(collectionName);
        var selectedCount = (selectedColorsByCollection[collectionName] || []).length;

        var listItem = document.createElement('li');
        listItem.className = 'custom-fabric-material-card';
        if (activeCollection === collectionName) {
          listItem.classList.add('is-selected');
        }

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-fabric-material-card__button';
        button.setAttribute('data-collection', collectionName);

        var imageWrap = document.createElement('div');
        imageWrap.className = 'custom-fabric-material-card__image';
        if (meta.image) {
          var image = document.createElement('img');
          image.src = meta.image;
          image.alt = collectionName;
          image.loading = 'lazy';
          imageWrap.appendChild(image);
        }

        var body = document.createElement('div');
        body.className = 'custom-fabric-material-card__body';

        var title = document.createElement('h4');
        title.className = 'custom-fabric-material-card__title';
        title.textContent = collectionName;
        body.appendChild(title);

        if (meta.subText) {
          var subText = document.createElement('p');
          subText.className = 'custom-fabric-material-card__meta';
          subText.textContent = meta.subText;
          body.appendChild(subText);
        }

        if (selectedCount) {
          var countTag = document.createElement('p');
          countTag.className = 'custom-fabric-material-card__count';
          countTag.textContent = selectedCount + ' color' + (selectedCount > 1 ? 's selected' : ' selected');
          body.appendChild(countTag);
        }

        button.appendChild(imageWrap);
        button.appendChild(body);

        button.addEventListener('click', function () {
          activeCollection = collectionName;
          if (nextButton) {
            nextButton.disabled = false;
          }
          renderMaterialCards();
          renderColorCards();
          setStep(2);
        });

        listItem.appendChild(button);
        materialGrid.appendChild(listItem);
      });

      if (nextButton) {
        nextButton.disabled = !activeCollection;
      }
      syncStepTwoAvailability();
    }

    function toggleColor(colorName) {
      if (!activeCollection) return;
      var selectedForCollection = selectedColorsByCollection[activeCollection] || [];
      var existingIndex = selectedForCollection.indexOf(colorName);

      // --- Multi-select logic (commented out for future use) ---
      // if (existingIndex > -1) {
      //   selectedForCollection.splice(existingIndex, 1);
      // } else {
      //   selectedForCollection.push(colorName);
      // }

      // if (selectedForCollection.length) {
      //   selectedColorsByCollection[activeCollection] = selectedForCollection;
      // } else {
      //   delete selectedColorsByCollection[activeCollection];
      // }
      // --- End multi-select logic ---

      // Single-select: only one fabric (material + color) at a time.
      if (existingIndex > -1) {
        selectedColorsByCollection = {};
      } else {
        selectedColorsByCollection = {};
        selectedColorsByCollection[activeCollection] = [colorName];
      }

      renderColorCards();
      renderMaterialCards();
      updatePreview();
      setApplyState();

      // Inline mode selects like the builder's stock fabric tiles: picking a
      // colour IS the choice — no Apply step between the click and the order.
      if (isInline) {
        var inlineValue = formatSelectionValue();
        var inlineParts = getSelectionParts();
        updateSelectedFabricDisplay(inlineValue);
        updateProductFormProperty(inlineValue);
        document.dispatchEvent(
          new CustomEvent('custom-fabric:applied', {
            detail: { value: inlineValue, material: inlineParts.material, color: inlineParts.color },
          })
        );
      }
    }

    function renderColorCards() {
      colorGrid.innerHTML = '';

      if (!activeCollection) {
        var emptyItem = document.createElement('p');
        emptyItem.className = 'custom-fabric-empty';
        emptyItem.textContent = 'Pick a material first.';
        colorGrid.appendChild(emptyItem);
        if (specLink) {
          specLink.classList.add('is-hidden');
          specLink.removeAttribute('href');
        }
        return;
      }

      if (colorHeading) {
        colorHeading.textContent = 'Choose a Colour - ' + activeCollection;
      }

      var selectedForCollection = selectedColorsByCollection[activeCollection] || [];
      var seenColors = {};
      var colorSource = fabricsByCollection[activeCollection] || [];
      var colorEntries = colorSource.filter(function (entry) {
        var key = entry.color.toLowerCase();
        if (seenColors[key]) return false;
        seenColors[key] = true;
        return true;
      });

      var specUrl = getCollectionMeta(activeCollection).specificationSheetUrl || '';

      if (specLink) {
        if (specUrl) {
          specLink.classList.remove('is-hidden');
          specLink.href = specUrl;
        } else {
          specLink.classList.add('is-hidden');
          specLink.removeAttribute('href');
        }
      }

      if (!colorEntries.length) {
        var noColorsItem = document.createElement('p');
        noColorsItem.className = 'custom-fabric-empty';
        noColorsItem.textContent = 'No colors configured for this material yet.';
        colorGrid.appendChild(noColorsItem);
        return;
      }

      colorEntries.forEach(function (entry) {
        var item = document.createElement('li');
        item.className = 'custom-fabric-color-card';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-fabric-color-card__button';
        if (selectedForCollection.indexOf(entry.color) > -1) {
          button.classList.add('is-selected');
        }

        var swatch = document.createElement('div');
        swatch.className = 'custom-fabric-color-card__swatch';
        if (entry.image) {
          var image = document.createElement('img');
          image.src = entry.image;
          image.alt = entry.color;
          image.loading = 'lazy';
          swatch.appendChild(image);
        }
        button.appendChild(swatch);

        var colorName = document.createElement('p');
        colorName.className = 'custom-fabric-color-card__name';
        colorName.textContent = entry.color;

        button.addEventListener('click', function () {
          toggleColor(entry.color);
        });

        item.appendChild(button);
        item.appendChild(colorName);
        colorGrid.appendChild(item);
      });
    }

    function openDrawer(sourceTrigger) {
      if (sourceTrigger) {
        setActiveProductFormFromTrigger(sourceTrigger);
      }
      syncCurrentSelectionToForm();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      // Inline mode sits in the page flow — locking the page would strand it.
      if (!isInline) {
        document.documentElement.classList.add('no-scroll-custom-fabric');
      }
      renderMaterialCards();
      renderColorCards();
      updatePreview();
      setApplyState();
      syncStepTwoAvailability();
      setStep(1);
      if (isInline && typeof drawer.scrollIntoView === 'function') {
        drawer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll-custom-fabric');
    }

    function applyFabricSelection(options) {
      var shouldOrderSample = !!(options && options.orderSample);
      var value = formatSelectionValue();
      updateSelectedFabricDisplay(value);
      updateProductFormProperty(value);
      /* REENABLE_CUSTOMIZATION_ADDON
      updateCustomizationAddonPreference(value);
      */
      updateOrderFabricSamplePreference(shouldOrderSample);
      closeDrawer();
      // Announced for pages that hold their own build state instead of an
      // add-to-cart form (e.g. the Yakka builder) — the form-based product
      // page path above ignores it.
      var appliedParts = getSelectionParts();
      document.dispatchEvent(
        new CustomEvent('custom-fabric:applied', {
          detail: { value: value, material: appliedParts.material, color: appliedParts.color },
        })
      );
    }

    function addFabricSampleToCartWithSelection() {
      var selectionValue = formatSelectionValue();
      var parsedSampleVariantId = Number(sampleVariantId);
      if (!selectionValue || !Number.isFinite(parsedSampleVariantId) || parsedSampleVariantId <= 0) return;

      if (applyAndOrderButton) {
        applyAndOrderButton.disabled = true;
        applyAndOrderButton.setAttribute('aria-disabled', 'true');
      }

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var payload = {
        items: [
          {
            id: parsedSampleVariantId,
            quantity: 1,
            properties: {}
          }
        ]
      };
      payload.items[0].properties[CUSTOM_FABRIC_PROPERTY_NAME] = selectionValue;

      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      var cartAddUrl =
        (typeof routes !== 'undefined' && routes.cart_add_url) ||
        (window.routes && window.routes.cart_add_url) ||
        '/cart/add.js';

      fetch('' + cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.text().then(function (bodyText) {
            var responseJson = null;

            if (bodyText) {
              try {
                responseJson = JSON.parse(bodyText);
              } catch (parseError) {
                if (response.ok) {
                  throw new Error('Unexpected non-JSON response from cart add endpoint.');
                }
              }
            }

            if (!response.ok) {
              var errorMessage =
                (responseJson && (responseJson.description || responseJson.message)) ||
                ('Cart add failed with status ' + response.status + '.');
              throw new Error(errorMessage);
            }

            if (!responseJson) {
              throw new Error('Cart add returned an empty response.');
            }

            return responseJson;
          });
        })
        .then(function (response) {
          if (response && response.status) return;

          closeDrawer();

          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }

          if (typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (applyAndOrderButton) {
            applyAndOrderButton.removeAttribute('aria-disabled');
          }
          setApplyState();
        });
    }

    function bindTriggers() {
      var labelTriggers = document.querySelectorAll('.swatch-input__label[data-custom-fabric-trigger="true"]');
      var inputTriggers = document.querySelectorAll('.swatch-input__input[value="Customise Fabric"]');

      if (!labelTriggers.length && !inputTriggers.length) return;

      labelTriggers.forEach(function (trigger) {
        if (trigger.dataset.customFabricBound === 'true') return;
        trigger.dataset.customFabricBound = 'true';
        trigger.addEventListener('click', function () {
          setActiveProductFormFromTrigger(trigger);
          openDrawer(trigger);
        });
      });

      inputTriggers.forEach(function (input) {
        if (input.dataset.customFabricBound === 'true') return;
        input.dataset.customFabricBound = 'true';

        input.addEventListener('change', function () {
          setActiveProductFormFromTrigger(input);
          if (input.checked) {
            openDrawer(input);
          }
        });

        input.addEventListener('click', function () {
          setActiveProductFormFromTrigger(input);
          setTimeout(function () {
            if (input.checked) {
              openDrawer(input);
            }
          }, 0);
        });
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        if (!activeCollection) return;
        renderColorCards();
        setStep(2);
      });
    }

    if (backButton) {
      backButton.addEventListener('click', function () {
        setStep(1);
      });
    }

    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFabricSelection({ orderSample: false });
      });
    }

    if (applyAndOrderButton) {
      applyAndOrderButton.addEventListener('click', function () {
        addFabricSampleToCartWithSelection();
      });
    }

    stepTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var requestedStep = Number(tab.getAttribute('data-custom-fabric-step-tab'));
        if (requestedStep === 2 && !activeCollection) return;
        setStep(requestedStep);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    customFabricApi = {
      clearOnStockSwatch: function (triggerInput) {
        if (!triggerInput || triggerInput.tagName !== 'INPUT') return;
        if (triggerInput.value === 'Customise Fabric') return;
        if (!triggerInput.checked) return;

        setActiveProductFormFromTrigger(triggerInput);

        selectedColorsByCollection = {};
        activeCollection = collections.length ? collections[0] : '';
        updatePreview();
        updateSelectedFabricDisplay('');
        updateProductFormProperty('');
        updateOrderFabricSamplePreference(false);

        var productForm = getTargetProductForm();
        if (productForm) {
          productForm.removeAttribute('data-customization-addon-variant-id');
          productForm.removeAttribute('data-addon-for-product-name');
        }
      }
    };

    bindTriggers();
    syncCurrentSelectionToForm();

    // Programmatic open for triggers this file cannot bind to — the Yakka
    // builder re-renders its swatch tiles on every choice, so a one-time
    // bindTriggers() pass would lose them.
    document.addEventListener('custom-fabric:open', function (event) {
      var trigger = event && event.detail && event.detail.trigger;
      if (trigger) setActiveProductFormFromTrigger(trigger);
      openDrawer(trigger || null);
    });

    document.addEventListener('custom-fabric:close', function () {
      closeDrawer();
    });

    document.addEventListener('shopify:section:load', function () {
      bindTriggers();
      syncCurrentSelectionToForm();
    });
    document.addEventListener('shopify:block:select', function () {
      bindTriggers();
      syncCurrentSelectionToForm();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomFabricDrawer);
  } else {
    initCustomFabricDrawer();
  }
})();
